import { Checkbox } from "@mui/material";
import { MUIDataTableMeta } from "mui-datatables";

import { Item } from "src/common/hooks/rowSelection";

export const customHeadLabelRender = (rowStore: {
  checkAllForPage: () => void;
  clearPage: () => void;
  allCheckedPage: () => boolean;
  partiallyCheckedPage: () => boolean;
}) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    if (checked) {
      rowStore.checkAllForPage();
    } else {
      rowStore.clearPage();
    }
  };

  return (
    <Checkbox
      checked={rowStore?.allCheckedPage()}
      indeterminate={rowStore?.partiallyCheckedPage()}
      inputProps={{ "aria-checked": "mixed" }}
      onChange={onChange}
    />
  );
};

export const customBodyRender = (
  tableMeta: MUIDataTableMeta,
  resourceIdIndex: number,
  rowStore: {
    add: (resourceId: string, item: Item) => void;
    del: (resourceId: string) => void;
    isChecked: (resourceId: string) => boolean;
  }
) => {
  const resourceId = tableMeta.rowData?.[resourceIdIndex]; // Column from which resource id comes from
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dataIndex = tableMeta.currentTableData[tableMeta.rowIndex].index; // Insert the proper index into store
    const checked = e.target.checked;
    if (checked) {
      rowStore.add(resourceId, {
        dataIndex: dataIndex,
        tableIndex: tableMeta.rowIndex,
      });
    } else {
      rowStore.del(resourceId);
    }
  };

  return (
    <Checkbox checked={rowStore?.isChecked(resourceId)} onChange={onChange} inputProps={{ "aria-label": resourceId }} />
  );
};
